import type { WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core';
import type { ReactElement } from 'react';
import z from 'z';
import CurrencyLabelRaw from '../../general/currency-label';
import DateLabelRaw from '../../general/date/date-label';

interface LabelledPropsStyled {
  label?: string;
  fallback?: string;
  prefix?: string;
  postfix?: string;
  value?: string | any;
  dataTestId?: string;
  children?:
    | ReactElement
    | ((null | false) | ReactElement)
    | ReactElement[]
    | ((null | false) | ReactElement)[];
}
interface LabelledProps {
  label?: string;
  fallback?: string;
  prefix?: string;
  postfix?: string;
  value?: string | any;
  dataTestId?: string;
  children?:
    | ReactElement
    | ((null | false) | ReactElement)
    | ReactElement[]
    | ((null | false) | ReactElement)[];
}

const Label = ({
  label = '',
  value,
  fallback = '',
  children,
  prefix = '',
  postfix = '',
  dataTestId
}: LabelledProps) => (
  <>
    <div className="text-neutral-faded font-medium">{z.format(label)}</div>
    <div className="text-neutral min-w-0" data-testid={dataTestId}>
      {prefix}
      {children ? children : value || fallback}
      {postfix}
    </div>
  </>
);
Label.displayName = 'Label';

interface LabelGroupProps extends WithStyles<typeof labelGridStyles> {
  children?: ReactElement[];
}

const labelGridStyles = {
  grid: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    gridRowGap: 10,
    gridColumnGap: 12,
    alignItems: 'baseline',
    width: '100%',
    overflowWrap: 'break-word'
  }
};

const LabelGroup = withStyles(labelGridStyles)(({ children, classes }: LabelGroupProps) => (
  <div className={classes.grid}>{children}</div>
));

const DateLabel = ({ label, value, fallback }: LabelledProps) => (
  <Label label={label}>
    <DateLabelRaw value={value} fallback={fallback} />
  </Label>
);

const CurrencyLabel = ({ label, value, fallback }: LabelledProps) => (
  <Label label={label}>
    <CurrencyLabelRaw value={value} fallback={fallback} />
  </Label>
);
export { Label, LabelGroup, DateLabel, CurrencyLabel };
